import classnames from "classnames";
import React, { useState } from "react";

import { LocationService } from "@services/location.service";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";

type Props = {
    label: string;
    onCurrentLocationSuccess: (latitude: number, longitude: number) => void;
    onCurrentLocationError: (errorMessage: string) => void;
    className?: string;
};

const CurrentLocationLink = ({
    label,
    onCurrentLocationSuccess,
    onCurrentLocationError,
    className,
}: Props) => {
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useGranite();

    const onCurrentLocationClick = () => {
        setIsLoading(true);

        LocationService.getCurrentPosition()
            .then(({ latitude, longitude }) => {
                onCurrentLocationSuccess &&
                    onCurrentLocationSuccess(latitude, longitude);
            })
            .catch(errorMessage => {
                if (onCurrentLocationError) {
                    onCurrentLocationError(t(errorMessage));
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <Button
            type={"button"}
            test="currentLocationLink-button-getCurrentPosition"
            color={"link"}
            disabled={isLoading}
            className={classnames("px-0", className)}
            onClick={onCurrentLocationClick}
        >
            <i
                className={`mr-2 las ${
                    isLoading ? "la-spinner la-pulse" : "la-map-marker"
                }`}
            />
            {label}
        </Button>
    );
};

export { CurrentLocationLink };
